import React, { useState } from "react";
import logo from "../assets/diksha-logo.png";
import footerDesign from "../assets/bg2.png";
import backgroundImg from "../assets/bg1.png";
import { TextField, InputAdornment, IconButton, Box } from "@mui/material";
import { GridVisibilityOffIcon } from "@mui/x-data-grid";
import { BASE_API_URL } from "../API/Base";
import toast from "react-hot-toast";
import axios from "axios";
import { LoginResponse } from "../types";
import { useTokenStore } from "../Zustand/TokenStore";
import { useAuthStore } from "../Zustand/AuthStore";
import LoadingAnimation from "../Components/LoadingAnimation";

interface LoginFormValues {
  email_id: string;
  password: string;
}

const Login = () => {
  const [formData, setFormData] = useState<LoginFormValues>({
    email_id: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { authenticate } = useAuthStore();
  const handleInputChange = (field: string, value: string | any) => {
    setFormData((prevData) => ({ ...prevData, [field]: value }));
  };

  const handleLogin = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${BASE_API_URL}/admin/v2/login`,
        formData
      );
      if (response.status === 200) {
        // toast.success("Login successful");
        const data: LoginResponse = response.data;
        const access = data.access_token;

        useTokenStore.setState({
          accessToken: access,

          AuthData: data,
        });

        authenticate();
      }
    } catch (error) {
      toast.error("Login failed");
    } finally {
      setLoading(false); // Set loading back to false after login attempt
    }
  };

  return (
    <div
      className="min-h-full h-screen flex items-center justify-center relative"
      style={{
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundPositionX: "50%",
        backgroundPositionY: "50%",
      }}
    >
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <LoadingAnimation />
        </Box>
      )}{" "}
      <div className="flex flex-col items-center justify-between w-full">
        <img
          src={logo}
          alt="Diksha.Online logo"
          className="md:w-1/6 w-1/2 text-center"
        ></img>
        <div className="flex flex-col justify-center">
          <form className="max-w-[600px] w-full mx-auto rounded-lg p-8 px-8 mb-28">
            <div className="mb-4 space-y-px">
              <TextField
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="email_id"
                type="email"
                name="email_id"
                placeholder="Enter your email"
                value={formData.email_id}
                onChange={(e) => handleInputChange("email_id", e.target.value)}
                autoComplete="email_id"
                size="small"
                required
              />
            </div>
            <div className="mb-6 -space-y-px">
              <TextField
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                id="password"
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Enter your password"
                value={formData.password}
                onChange={(e) => handleInputChange("password", e.target.value)}
                autoComplete="off"
                size="small"
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge="end"
                      >
                        {showPassword ? (
                          <GridVisibilityOffIcon />
                        ) : (
                          <GridVisibilityOffIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div className="flex items-center justify-center">
              <button
                type="button"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 mt-5"
                onClick={handleLogin}
              >
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 w-full bg-red-900">
        <img
          src={footerDesign}
          alt="footer design"
          className="fixed bottom-0 left-0 w-full h-auto"
        />
      </div>
    </div>
  );
};

export default Login;

// eslint-disable-next-line no-lone-blocks
{
  /* <div
        style={backgroundStyle}
        className="min-h-full h-screen flex items-center justify-center relative"
      >
     
        <div className="w-full">
          <Header heading="Login to your account"></Header>
          <Login></Login>
          <img src={bg2} alt="bg2" className="fixed bottom-0 left-0 w-full h-auto" />
        </div>
      </div> */
}
